import OpportunityCardBody from './opportunityCardBody.view';

export default OpportunityCardBody;
